import { useMutation } from '@tanstack/react-query';

import { LaunchQuizEventAdapter } from '~analytics/adapters/LaunchQuizEventAdapter';

import { startQuiz } from '../../../api/activities/startQuiz';

export function useStartQuizMutation() {
  return useMutation({
    mutationFn: startQuiz,
    onSuccess: (
      _data,
      { settings, roomHasRoster, workspaceId, workspaceQuizId, launchRoute }
    ) => {
      new LaunchQuizEventAdapter({
        settings: settings,
        isRosteredRoom: roomHasRoster,
        launchRoute: launchRoute,
        workspaceData:
          workspaceId && workspaceQuizId
            ? {
                workspace_id: workspaceId,
                workspace_quiz_id: workspaceQuizId,
              }
            : null,
      }).sendAnalytics();
    },
  });
}
